import React from 'react';
import Link from 'next/link';

export const Information = () => {
  return (
    <div className="mx-auto my-[30px] w-mobile pb-[5%] text-left lg:w-[calc(40%-50px)] lg:max-w-[300px]">
      <h5 className="mb-2.5 text-[16px]">Homeowner support</h5>
      <p className="text-[14px] text-gray-500">
        Need support for your Clayton Built&reg; home? Contact our Customer
        Advocacy Team at <Link href="tel:1-877-264-2812" className="text-nowrap">1-877-264-2812</Link>{' '}
        or{' '}
        <Link href="mailto:customeradvocacy@claytonhomes.com">
          CustomerAdvocacy@claytonhomes.com
        </Link>
      </p>
      <hr className="my-4 w-full border-t border-gray-300" />
      <h5 className="mb-2.5 mt-4 text-[16px]">Home office</h5>
      <h6 className="mb-2.5 mt-[5px] text-[14px]">Mailing address</h6>
      <p className="text-[14px] text-gray-500"> 5000 Clayton Road,</p>
      <p className="text-[14px] text-gray-500">Maryville, TN 37804</p>
      <h6 className="mb-2.5 mt-[5px] text-[14px]">Phone</h6>
      <p className="text-[14px] text-gray-500">
        <Link href="tel:1-865-380-3000">(865) 380-3000</Link>
      </p>
      <hr className="my-4 w-full border-t border-gray-300" />
      <h5 className="mb-2.5 mt-4 text-[16px]">Media Requests</h5>
      <p className="text-[14px] text-gray-500">
        Requests can be emailed to{' '}
        <Link href="mailto:media@claytonhomes.com">media@claytonhomes.com</Link>{' '}
        or you can visit our{' '}
        <Link
          href="https://www.claytonhomes.com/newsroom/"
          rel="noopenner noreferrer"
          target="_blank"
        >
          Newsroom
        </Link>
        .
      </p>
    </div>
  );
};
